import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";
import {RouterProps} from "../../RouterProps";
import PopularRouter from "./popular/PopularRouter";

export default function QueryRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:contentQueryId'} element={<Detail {...props} />} />
            <Route path={'/populars/*'} element={<PopularRouter {...props} />} />
        </Routes>
    </>
}